

function Footer(){

return(
    <footer className="foot">
            <div>
                <p>Proyecto desarrollado para: THE BRIDGE</p>
                <p>Más información pongase en contacto con: isensoja@gmail.com</p>
            </div>
            <div className="redes">
            <ion-icon name="logo-linkedin" size="large"></ion-icon> <a href="https://www.linkedin.com/in/isidro-c-benito/" target="_blank">www.linkedin.com/in/isidro-c-benito</a>
                <br></br>
                <ion-icon name="logo-instagram" size="large"></ion-icon> <span>https://www.instagram.com/isensoja/</span>
            </div>
    </footer>

)

}

export default Footer